module.exports = require("@nextcloud/auth");